import httpServer from "../axios";
import {baseUrlx} from "..";

export default {
  // 省
  loginIn(params) {
    return httpServer('post',baseUrlx + "api/school/login", params);
  }
};